import React from "react";
import { useMap } from "react-leaflet";

/**
 * RecenterButton - A Leaflet control component that adds a button to recenter the map
 * @param {Array} position - [lat, lng] coordinates to center on
 * @param {Number} zoom - Zoom level (default: 14)
 */
const RecenterButton = ({ position, zoom = 14 }) => {
  const map = useMap();

  const handleRecenter = () => {
    if (position && position.length === 2) {
      map.setView(position, zoom, {
        animate: true,
        duration: 0.5,
      });
    }
  };

  React.useEffect(() => {
    // Create a custom control
    const RecenterControl = window.L.Control.extend({
      onAdd: function () {
        const button = window.L.DomUtil.create("button", "leaflet-bar leaflet-control");
        
        button.type = "button"; // Prevent form submission when inside a form
        button.innerHTML = `
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <circle cx="12" cy="12" r="3"/>
            <circle cx="12" cy="12" r="10"/>
            <line x1="12" y1="2" x2="12" y2="6"/>
            <line x1="12" y1="18" x2="12" y2="22"/>
            <line x1="2" y1="12" x2="6" y2="12"/>
            <line x1="18" y1="12" x2="22" y2="12"/>
          </svg>
        `;
        
        button.title = "Recenter to your location";
        button.style.backgroundColor = "white";
        button.style.border = "2px solid rgba(0,0,0,0.2)";
        button.style.borderRadius = "4px";
        button.style.width = "34px";
        button.style.height = "34px";
        button.style.cursor = "pointer";
        button.style.display = "flex";
        button.style.alignItems = "center";
        button.style.justifyContent = "center";
        button.style.padding = "0";
        button.style.transition = "all 0.2s";
        
        // Hover effects
        button.onmouseenter = () => {
          button.style.backgroundColor = "#f0f0f0";
          button.style.transform = "scale(1.05)";
        };
        button.onmouseleave = () => {
          button.style.backgroundColor = "white";
          button.style.transform = "scale(1)";
        };
        
        button.onclick = (e) => {
          e.stopPropagation();
          handleRecenter();
        };
        
        // Prevent map interactions when clicking the button
        window.L.DomEvent.disableClickPropagation(button);
        
        return button;
      },
    });

    // Add control to top right corner
    const control = new RecenterControl({ position: "topright" });
    control.addTo(map);

    // Cleanup on unmount
    return () => {
      control.remove();
    };
  }, [map, position, zoom]);

  return null;
};

export default RecenterButton;
